import { createApi } from "@reduxjs/toolkit/query/react";
import { listTrapsResponse } from "../../types";
import { axiosBaseQuery } from "../../providers/auth0-instance";
import { withErrorNotification } from "../notifications";

export const trapApi = createApi({
  reducerPath: "trapApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Trap"],
  endpoints: (builder) => ({
    listTraps: builder.query<listTrapsResponse, void>({
      query: () => ({ url: "/traps" }),
      providesTags: ["Trap"],
      onQueryStarted: withErrorNotification("Failed to list traps"),
    }),
  }),
});

export const { useListTrapsQuery } = trapApi;
